import { getApiInstance } from '../helpers';
import { TicketLoadResDataI } from '../models/Ticket';

/**
 * read gmail -> trigger backend to read the gmail and store in the ticket
 * this might not need when we do pre processing
 * @param param0
 */
const loadTicket = (ticketId: string) => {
  return getApiInstance()
    .post('/ticket/load', {
      id: ticketId,
    })
    .then(
      (res): TicketLoadResDataI => {
        // the old version, set from_addon to false after too
        // not sure if still have to do that
        console.info('/ticket/load result', res);
        const ret = res.data;
        // // for testing detectedSiKind ui feature
        // ret.ticket = {
        //   ...ret.ticket,
        //   status: 'SI_READY',
        //   // detectedSiKind: 'S-Split',
        //   // detectedUrgency: 'U-Urgent',
        // };
        return ret;
      },
    );
};

const deleteFiles = (partIds: string[], ticketId: string) => {
  const params = { partIds, id: ticketId };
  console.debug(`deleteFiles params: `, params);
  return getApiInstance()
    .post('/ticket/delete-files', params)
    .then((res) => {
      // the old version, set from_addon to false after too
      // not sure if still have to do that
      console.info('/ticket/deleteFiles result', res);
      return res.data;
    });
};

const submitBooking = (params) => {
  return getApiInstance()
    .post('/ticket/submit', params)
    .then((res) => {
      // the old version, set from_addon to false after too
      // not sure if still have to do that
      console.info('/ticket/submit result', res);
      return res.data;
    });
};

/**
 * add new time tracking
 * @param params
 * @returns
 */
const postTimeTracking = (params: {
  ticketId: string;
  email: string;
  status: string;
  durationInSeconds: number;
  note: string;
  createdBySystem: boolean;
}) => {
  return getApiInstance()
    .post('/time-tracking/add', params)
    .then((res) => {
      console.log('post /time-tracking result', res);
      return res.data;
    });
};
/**
 * update time tracking at id
 * the durationInSeconds will be replaced with the new durationInSeconds in the db
 * @param params
 * @returns
 */
const patchTimeTracking = (params: {
  id: string;
  durationInSeconds: number;
  status: string;
  updatedBySystem: boolean;
}) => {
  return getApiInstance()
    .patch('/time-tracking/update', params)
    .then((res) => {
      console.info('patch /time-tracking/update result', res);
      return res.data;
    });
};
const postGetTimeTracking = (params: {
  ticketId: string;
  email: string;
}) => {
  return getApiInstance()
    .post('/time-tracking/get-total-duration', params)
    .then((res) => {
      console.info(
        'post /time-tracking/get-total-duration result',
        res,
      );
      return res.data;
    });
};
const postAutoUnassignTimeTracking = (params: {
  ticketId: string;
  durationInSeconds: number;
  note: string;
  email: string;
}) => {
  return getApiInstance()
    .post('/time-tracking/auto-unassign', params)
    .then((res) => {
      console.info('post /time-tracking/auto-unassign result', res);
      return res.data;
    });
};
const saveTicket = (ticketId: string, data, changeFlag) => {
  return getApiInstance()
    .post('/ticket/save', { id: ticketId, data, changeFlag })
    .then((res) => {
      // the old version, set from_addon to false after too
      // not sure if still have to do that
      console.info('/ticket/save result', res);
      return res.data;
    });
};

const preprocessGmail = (id: string, inbox: string) => {
  return getApiInstance()
    .post('/ticket/preprocess-gmail', { id: id, inbox: inbox })
    .then((res) => {
      // the old version, set from_addon to false after too
      // not sure if still have to do that
      console.info('/ticket/preprocess-gmail result', res);
      return res.data;
    });
};

export const ticketService = {
  loadTicket,
  deleteFiles,
  submitBooking,
  saveTicket,
  preprocessGmail,
  postTimeTracking,
  patchTimeTracking,
  postGetTimeTracking,
  postAutoUnassignTimeTracking,
};
